import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "@/context/AuthContext";
import { ContenidoProvider } from "@/context/ContenidoContext";
import PublicLayout from "@/components/layout/PublicLayout";
import CustomCursor from "@/components/layout/CustomCursor";
import SmoothScroll from "@/components/layout/SmoothScroll";
import ScrollToTop from "@/components/layout/ScrollToTop";
import Home from "@/pages/Home";
import Gastronomia from "@/pages/Gastronomia";
import Museo from "@/pages/Museo";
import Eventos from "@/pages/Eventos";
import Reservas from "@/pages/Reservas";
import Contacto from "@/pages/Contacto";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Premios from "@/pages/Premios";

import CrmLogin from "@/pages/crm/CrmLogin";
import CrmLayout from "@/components/crm/CrmLayout";
import CrmDashboard from "@/pages/crm/CrmDashboard";
import CrmReservas from "@/pages/crm/CrmReservas";
import CrmCalendario from "@/pages/crm/CrmCalendario";
import CrmClientes from "@/pages/crm/CrmClientes";
import CrmClienteDetalle from "@/pages/crm/CrmClienteDetalle";
import CrmEventos from "@/pages/crm/CrmEventos";
import CrmEventoDetalle from "@/pages/crm/CrmEventoDetalle";
import CrmCarta from "@/pages/crm/CrmCarta";
import CrmContenido from "@/pages/crm/CrmContenido";
import CrmBlog from "@/pages/crm/CrmBlog";

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <CustomCursor />
                <AuthProvider>
                    <ContenidoProvider>
                        <SmoothScroll>
                            <BrowserRouter>
      <ScrollToTop />
                                <Routes>
                                    {/* Public */}
                                    <Route element={<PublicLayout />}>
                                        <Route path="/" element={<Home />} />
                                        <Route path="/gastronomia" element={<Gastronomia />} />
                                        <Route path="/museo" element={<Museo />} />
                                        <Route path="/eventos" element={<Eventos />} />
                                        <Route path="/reservas" element={<Reservas />} />
                                        <Route path="/contacto" element={<Contacto />} />
                                        <Route path="/blog" element={<Blog />} />
                                        <Route path="/blog/:slug" element={<BlogPost />} />
                                        <Route path="/premios" element={<Premios />} />
                                    </Route>

                                    {/* CRM */}
                                    <Route path="/crm/login" element={<CrmLogin />} />
                                    <Route path="/crm" element={<CrmLayout />}>
                                        <Route index element={<CrmDashboard />} />
                                        <Route path="reservas" element={<CrmReservas />} />
                                        <Route path="calendario" element={<CrmCalendario />} />
                                        <Route path="clientes" element={<CrmClientes />} />
                                        <Route path="clientes/:id" element={<CrmClienteDetalle />} />
                                        <Route path="eventos" element={<CrmEventos />} />
                                        <Route path="eventos/:id" element={<CrmEventoDetalle />} />
                                        <Route path="carta" element={<CrmCarta />} />
                                        <Route path="contenido" element={<CrmContenido />} />
                                        <Route path="blog" element={<CrmBlog />} />
                                    </Route>

                                    <Route path="*" element={<Navigate to="/" />} />
                                </Routes>
                            </BrowserRouter>
                        </SmoothScroll>
                    </ContenidoProvider>
                    <Toaster
                        theme="dark"
                        position="top-right"
                        toastOptions={{
                            style: {
                                background: "var(--bg-alt)",
                                color: "var(--ivory)",
                                border: "1px solid var(--gold)",
                                borderRadius: 0,
                                fontFamily: '"Inter", sans-serif',
                            },
                        }}
                    />
                </AuthProvider>
            </HelmetProvider>
        </div>
    );
}

export default App;
